import axios, {CancelTokenSource} from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, AssemblyDocument} from '../api/models';
import { ConfiguratorContext } from '../context';

interface AssemblyDocumentsProps {
  assemblyId:number | undefined
}

export const useAssemblyDocuments = (props: AssemblyDocumentsProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:AssemblyDocumentsProps  ) : Promise<AssemblyDocument[] | undefined> => {

    const { assemblyId } = props;
    if (!assemblyId) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchAssemblyDocuments(assemblyId, cancelSource.token);
      cancelTokenSourceRef.current = undefined;
      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  return useSWR([
        'fetchAssemblyDocuments',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        revalidateOnFocus: false,
        dedupingInterval:1
    }
  );
};


export default useAssemblyDocuments;
